
    <section id="events-section">
      <div class="container">
        <div class="row mt-4 mb-4">
          <div class="col-md mt-3">
            <h2>Cadeautjes verzamelen </h2>
            <p>Verzamel cadeautjes en zet ze op je verlanglijstje!</p>
          </div>
    
          <div class="col-md mt-3">
            <h2>Verlanglijstje delen</h2>
            <p>Deel je verlanglijstje via WhatsApp, E-mail of via een link.</p>
          </div>
    
          <div class="col-md mt-3">
            <h2>Afstrepen</h2>
            <p>Diegene die jouw verlanglijstje hebben ontvangen, zoeken iets leuks uit en strepen het van je verlanglijstje.
            </p>
          </div>
        </div>
    
    
    
      </div>
    </section>
    
    

    <section id="questions-section">
      <div class="container">
        <div class="row mt-4">
          <div class="col-lg-7 ">
            <h2 class="custom-heading-black mt-3 mb-5">Vraag en antwoord</h2>
            <mat-expansion-panel class="mb-2">
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
                  <div class="expansion-panel mt-1 mb-1"> Hoe kan ik een verlanglijstje maken? </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="expansion-panel">
                <p>
                  De eerste stap is <a [routerLink]='["/auth/inloggen"]'>inloggen via Facebook</a> of een <a
                    [routerLink]='["/auth/aanmelden"]'>account aanmaken</a>.
                </p>
                <p>
                  Ben je vervolgens ingelogd, dan kom je automatisch op het scherm 'Verlanglijstje maken'. Je geeft je
                  lijstje
                  een naam en drukt vervolgens op 'Lijstje maken', nu wordt je verlanglijstje aangemaakt.
                </p>
                <p>
                  Je kunt voor elke gelegenheid een apart verlanglijstje maken, bijvoorbeeld een
                  verlanglijstje voor je <a [routerLink]='["/verjaardagslijstje"]'>verjaardag</a>, <a
                    [routerLink]='["/sinterklaas"]'>Sinterklaas</a>,
                  <a [routerLink]='["/kerst"]'>kerst</a>, <a [routerLink]='["/baby"]'>baby</a> of <a
                    [routerLink]='["/bruiloft"]'>bruiloft</a>.
                </p>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mb-2">
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
                  <div class="expansion-panel mt-1 mb-1"> Kan ik inspiratie opdoen voor mijn verlanglijstje?</div>
                </mat-panel-title>
    
              </mat-expansion-panel-header>
              <div class="expansion-panel ">
                <p>
                  Jazeker! Ga naar onze <a [routerLink]='["/catalogus"]'>Cadeauzoeker</a>. Je kunt daar makkelijk
                  zoeken en je krijgt zoeksuggesties die je op ideeën brengen. Je kunt kiezen voor categoriën en
                  filteren op bijvoorbeeld kleur of merk, daarnaast kun je sorteren op beoordeling, best verkocht,
                  prijs, etc.
                  Dit is één van de grote voordelen van verlanglijst.online. Snel zoeken, vinden en op je
                  verlanglijstje zetten.
                </p>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mb-2">
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
                  <div class="expansion-panel mt-1 mb-1"> Hoe zet ik een artikel op mijn verlanglijstje? </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="expansion-panel">
                <p>
                  Dat is heel eenvoudig! Als je ingelogd bent, ga je naar de <a
                    [routerLink]='["/catalogus"]'>Cadeauzoeker</a>. Zoek wat je hebben wilt en
                  druk vervolgens op 'Toevoegen'.
                  Selecteer op welk verlanglijstje (als je meerdere lijstjes hebt) je dit artikel wilt zetten. Geef
                  aan of je wilt dat mensen het
                  artikel kunnen afstrepen van je verlanglijstje.
                  Druk op 'Bevestigen'. Het artikel wordt vervolgens aan je verlanglijstje toegevoegd.<br><br>
                  Mocht je iets niet kunnen vinden in de Cadeauzoeker, dan heb je altijd de mogelijkheid om handmatig
                  iets toe te voegen aan je verlanglijstje.
                  Kies dan voor 'Zelf toevoegen' in de Cadeauzoeker. Wij ondersteunen <a [routerLink]='["/webwinkels"]'>alle
                    webwinkels</a>.
                </p>
              </div>
    
            </mat-expansion-panel>
            <mat-expansion-panel class="mb-2">
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
                  <div class="expansion-panel mt-1 mb-1">
                    Hoe kan ik mijn verlanglijstje delen met mensen?
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="expansion-panel">
                <p>
                  Als je ingelogd bent en naar 'Mijn Lijstjes & Lootjes' gaat, zie je daar al je verlanglijstjes die je
                  hebt gemaakt. Druk op 'Naar verlanglijstje', nu kom je in je verlanglijstje.
                  Elk verlanglijstje kun je delen via WhatsApp, Facebook en via een link. Deze link kun je
                  bijvoorbeeld in een <span class="line">e-mailtje</span> plakken of op een kaartje vermelden.
    
                  Als je kiest voor delen via WhatsApp of Facebook, kies je met wie je je verlanglijstje wilt
                  delen, of zet je het op je tijdlijn.
    
                </p>
                <p>
                  De ontvangers kunnen dan op de link drukken of deze overtypen. Jouw verlanglijstje komt in beeld
                  en ze kunnen makkelijk wat afstrepen, zonder dat ze zelf een account hoeven aan te maken.
                  Zo krijg jij geen cadeautjes dubbel.
                </p>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mb-2">
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
                  <div class="expansion-panel mt-1 mb-1">Waarom je voor verlanglijst.online kiest </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="expansion-panel">
                <p>
                  Wist je dat bij veel verlanglijstjes sites de artikelprijzen niet actueel zijn en dat als je het
                  éénmaal op je lijstje hebt staan prijswijzigingen niet worden bijgewerkt?
                  Dat is erg vervelend. Over het algemeen veranderen prijzen namelijk heel vaak. Het kan zomaar
                  zijn dat iets wat voor 20 euro op je verlanglijstje staat, de week erna ineens 30 euro kost, of
                  omgekeerd.
                  Als je bij ons iets via de <a [routerLink]='["/catalogus"]'>Cadeauzoeker</a> (dus niet via 'zelf
                  toevoegen') op je lijstje zet, blijven de prijzen
                  altijd actueel.
                </p>
                <p>
                  Verlanglijst.online heeft zeer uitgebreide zoekmogelijkheden, filters en sorteermogelijkheden,
                  jij vindt snel waarnaar je op zoek bent! Je kunt daarnaast makkelijk <a
                    [routerLink]='["/auth/inloggen"]'>inloggen via Facebook</a>.
                  Mensen die iets van je lijstje willen afstrepen hoeven zich bij ons niet te registreren.
                </p>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mb-2">
              <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
                <mat-panel-title>
                  <div class="expansion-panel mt-1 mb-1">Is Verlanglijst Online ook beschikbaar in andere talen? </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="expansion-panel">
                  <p>Verlanglijst Online heeft ook een Engelstalige versie: <a href="https://prettywishlist.com" target="_blank"
                    rel="noopener">Pretty Wish List</a>. Pretty Wish List werkt op dezelfde manier als Verlanglijst Online.</p>
              </div>
            </mat-expansion-panel>
    
            <div class="row mt-5 ">
              <div class="col">
                <button type="button" class="btn btn-primary btn-big shadow me-3 mb-5" routerLink="/help">
                  Alle vragen
                </button>
                <button type="button" class="btn btn-secondary shadow mb-5" routerLink="/contact">
                  Stel je vraag
                </button>
              </div>
            </div>
    
          </div>
          <div class="col-lg-5 d-none d-lg-block mt-5 ">
    
            <img src="../../../assets/images/veelgestelde_vragen.png" alt="veelgestelde vragen verlanglijstje maken"  height="325" width="400"
              class="d-none d-md-block d-lg-block ">
          </div>
        </div>
      </div>
    </section>
    